export class InvestigationReopeningReasonEntity {
  public id!: string;
  public name!: string;
  public sortOrder!: number;
}
